/**
 * globalize jquery for legacy modules and angular
 */

import jquery from 'jquery';
window.jQuery = jquery;
window.$ = jquery;


// WEBPACK FOOTER //
// ./src/mainModule/js/jquery-global.js